export default __webpack_public_path__ + "static/thumbnail-f5067b2e21f7a2c63572185231ced575.png";